export const LETTER_INDEX_MAP = {
  "0": "A",
  "1": "B",
  "2": "C",
  "3": "D",
  "4": "E",
  "5": "F",
  "6": "G",
  "7": "H",
  "8": "I",
  "9": "J",
  "10": "K",
  "11": "L",
  "12": "M",
  "13": "N",
  "14": "O",
  "15": "P",
  "16": "Q",
  "17": "R",
  "18": "S",
  "19": "T",
  "20": "U",
  "21": "V",
  "22": "W",
  "23": "X",
  "24": "Y",
  "25": "Z",
};

/**
 * Converts a 0-based index to a stable letter label.
 * 0→A, 1→B, …, 25→Z, 26→AA, 27→AB, … (Excel-column style).
 * Unlike LETTER_INDEX_MAP this works for any non-negative index.
 */
export function getLetterForIndex(index: number): string {
  let result = "";
  let n = index;
  do {
    result = String.fromCharCode(65 + (n % 26)) + result;
    n = Math.floor(n / 26) - 1;
  } while (n >= 0);
  return result;
}
